module.exports = __webpack_public_path__ + "static/media/img-4.38edb8a4.jpg";